import React, { useRef } from 'react'
import styled from 'styled-components'

import { SearchIcon } from '@/components/ui/icons'

const Container = styled.form.attrs({ role: 'search' })`
  width: 900px;

  display: flex;

  background-color: white;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
`

const Input = styled.input`
  flex: 1 0;

  padding: 17.5px;

  font-size: 1.2rem;

  border: none;
`

const Button = styled.button`
  height: 60px;
  width: 60px;

  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  color: white;

  cursor: pointer;
  background-image: linear-gradient(
    -135deg,
    #ff0090 20%,
    ${({ theme }) => theme.palette.giphyPurple} 100%
  );
  border: none;
`

type Props = {
  value: string
  onInput: (query: string) => void
  onSubmit: () => void
}

const Search = ({ value, onInput, onSubmit }: Props) => {
  const prevSearchQuery = useRef<string | null>(null)

  const onSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (value !== prevSearchQuery.current) {
      prevSearchQuery.current = value
      onSubmit()
    }
  }

  return (
    <Container onSubmit={onSearchSubmit}>
      <Input
        placeholder="Search for a topic or specific question…"
        value={value}
        onChange={(e) => onInput(e.target.value)}
      />
      <Button>
        <SearchIcon />
      </Button>
    </Container>
  )
}

export default Search
